var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fade',[(_vm.isVisible)?_c('a',{staticClass:"scroll-to-top fixed bg-black rounded-full text-white p-4",attrs:{"href":"#"}},[_vm._v(" Scroll to top ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }